(function () {
  function init() {
    document.querySelectorAll('.hdt-accordion-item').forEach(function (item) {
      if (item.dataset.accordionBound === '1') return;
      item.dataset.accordionBound = '1';

      var btn = item.querySelector('.hdt-accordion-summary');
      var wrap = item.querySelector('.hdt-accordion-content-wrap');
      if (!btn || !wrap) return;

      if (item.classList.contains('is-open')) {
        wrap.style.maxHeight = wrap.scrollHeight + 'px';
      }

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        if (isOpen) {
          wrap.style.maxHeight = wrap.scrollHeight + 'px';
          requestAnimationFrame(function () {
            wrap.style.maxHeight = '0px';
          });
          item.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          wrap.style.maxHeight = wrap.scrollHeight + 'px';
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });

      wrap.addEventListener('transitionend', function (e) {
        if (e.propertyName !== 'max-height') return;
        if (item.classList.contains('is-open')) {
          wrap.style.maxHeight = 'none';
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();